import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { GenericService } from "../../../services/generic.service";

@Component({
    selector: 'app-inline-checkboxes',
    templateUrl: './inline-checkboxes.component.html',
    styleUrls: ['./inline-checkboxes.component.scss'],
    standalone: false
})
export class InlineCheckboxesComponent implements OnInit {
  @Input() label: string;
  @Input() data: string[];
  @Input() disabledFlag: boolean;
  @Input() items: any[] = [];
  @Output() focusOut: EventEmitter<string[]> = new EventEmitter<string[]>();

  dataDate: Date;

  editMode = false;

  @HostListener('document:click', ['$event'])
  click(event) {
    if(
      !this.genericService.isDescendant("editMode", event.target) &&
      !this.genericService.isDescendant("simpleCheckbox", event.target) &&
      !this.genericService.isDescendant("selectPreviewData", event.target) &&
      this.editMode
    ) {
      this.editMode = false;
    }
  }

  constructor(private genericService: GenericService) {
  }

  ngOnInit() {
    for(let item of this.items){
      item.isChecked = this.data.indexOf(item.value) !== -1;
    }
  }

  onFocusOut(item) {
    item.isChecked = !item.isChecked;
    this.focusOut.emit(this.items.filter(i => i.isChecked).map(i => i.value));
  }

  undo() {
    this.editMode = false;
    //todo make it undo the changes
  }
}
